<script lang="ts">

    export let value = null;
    export let dataName = 'データ';

    export let paddingLeft = 0;
    export let paddingTop = 0;
    export let isCenter = false;

    $: isEmpty = (() => {
        if (value == null) {
            return true;
        }


        return false;
    })();

    $: emptyStyle = (() => {
        let style = '';
        if (paddingLeft > 0) {
            style += `padding-left: ${paddingLeft}px;`;
        }
        if (paddingTop > 0) {
            style += `padding-top: ${paddingTop}px;`;
        }
        if (isCenter) {
            style += 'justify-content: center;';
        }

        return style;
    })();

</script>

{#if isEmpty}
    <div class='empty' style={emptyStyle}>{dataName}が存在しません</div>
{:else}
    <slot/>
{/if}
<style lang="scss">
    .empty {
        opacity: 0.5;
        font-size: 0.8em;
    }


</style>